<template>
  <textarea :id="thisId" >

  </textarea>
</template>

<script>
import '../css/layout.css'
/*
import 'tinymce/themes/modern/theme.js'
import 'tinymce/skins/lightgray/skin.min.css'
import 'tinymce/skins/lightgray/content.min.css'
import 'tinymce/plugins/advlist/plugin.js'
import 'tinymce/plugins/autolink/plugin.js'
*/
import Vue from 'vue'
	Vue.directive('tinymce-page',{ 
  	twoWay: true,
    inserted: function(el, binding, vnode) {
      var self = el
      var selec = el.id
      console.log("CI ARRIVO ")
      console.log(this)
      tinymce.init({
      	selector: '#'+el.id,
        setup: function(editor) {
        console.log("SETUP TINYMCE________")
        console.log(el.value)
        	// init tinymce
        	editor.on('init', function() {
            if(el.value!='')
                tinymce.get(el.id).setContent(el.value);
          });
          
          // when typing keyup event
          editor.on('keyup change', function(e) {
          	//console.log(el.id)
            // get new value
          	var new_value = tinymce.get(el.id).getContent();
            //console.log(new_value)
            // set model value
            el.value = new_value
            
            //console.log(el.value)
          });
          
        }
      });
    },
    unbind:function(){
      tinymce.remove()
    },
    update: function(newVal, oldVal) {
    	// set val and trigger eventdescrizione
    	//$(this.el).val(newVal).trigger('keyup');
      console.log(newVal)
    }
  
  })


export default {
  props: ['height','language','initvalue'],
  created () {
    console.log("TINYMCE CREATO");
    this.thisId="tinymce-"+this.$teras.random()
  },  
  mounted (){
      this.tinymceInit()
    
  },
  destroyed(){
    tinymce.remove()
  },
  watch: {
    '$teras.language':  'terasChange'
  },
  methods: {
    terasChange(){
        tinymce.remove()
      //tinymce.init({language : self.$teras.language})
      console.log("DA ABS" + this.$teras.language)
      //tinyMCE.execCommand(“mceRepaint”);
      var self = this
      tinyMCE.execCommand("mceRepaint")
      this.tinymceInit()
    },
    tinymceInit(){
        var self = this
        console.log("MOUNTED ABS-TINYMCE "+this.height)
        console.log("MOUNTED TIPOEDITO "+this.$teras.evento.tipoeditor)
        

        console.log(self.$el.id)
        console.log(self.$teras.language)
        console.log(document.styleSheets[2])
        //tinyMCE.baseURL = "https://cdn.tinymce.com/4"
        tinyMCE.baseURL = "/bams/js/tinymce"
        this.tiny = tinymce.init({
            selector: '#'+self.$el.id,
            //menubar: true,
            //menubar: 'file edit insert view format',
            menubar: 'file edit',
            height: self.height,
            language : self.$teras.language,
            //language_url : '/201706/langs/it.js',
            content_css : "/bams/css/layout.css",
            //content_css : document.styleSheets[0],
            oninit : "setPlainText",
            entity_encoding : "raw",
            forced_root_block : false,
            underline: { inline: 'span', styles: { 'text-decoration': 'underline' }, exact: true },
            valid_elements :  (self.$teras.evento.tipoeditor==1) ? 'sup,sub,br,strong,em,span[style]' : 'br',

            relative_urls : false,
            plugins: [
            'paste',
            'charmap',
            'wordcount,fullscreen',
            'contextmenu ',
            ''
            ],
            //contextmenu: "charmap | subscript  superscript | copy paste",
            //toolbar1: 'undo redo |  styleselect | bold italic | subscript  superscript | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | charmap | fullscreen',
            //toolbar1: 'undo redo |   subscript  superscript |  bold italic underline | charmap | fullscreen',

            contextmenu: (self.$teras.evento.tipoeditor==1) ? "charmap | subscript  superscript | copy paste" : "charmap | copy paste",
            toolbar1: (self.$teras.evento.tipoeditor==1) ? 'undo redo |   subscript  superscript |  bold italic underline | charmap | fullscreen' : 'undo redo | charmap | fullscreen',
            
            setup: function(editor) {
            console.log("SETUP TINYMCE")
            console.log(self.$el.id)
                // init tinymce
                editor.on('init', function() {
                  //console.log(selfel.initValue)
                tinymce.get(self.$el.id).setContent(self.initvalue);

                var theEditor = tinymce.activeEditor
                var wordCount = theEditor.plugins.wordcount.getCount()
                var new_value = tinymce.get(self.$el.id).getContent()
                self.$emit('input', new_value)
                self.$emit('change', new_value, wordCount)
            });
            
            // when typing keyup event
            editor.on('keyup change', function(e) {
                
                var theEditor = tinymce.activeEditor
                var wordCount = theEditor.plugins.wordcount.getCount()

                var new_value = tinymce.get(self.$el.id).getContent()
                /*self.$el.value = new_value */
                self.$emit('input', new_value)
                self.$emit('change', new_value, wordCount)
                
                //console.log(new_value)
            });
            
            }
        })
        console.log(this.tiny)
        console.log("FINITA")
      }
  }
  
}

</script>
<style>

</style>


// WEBPACK FOOTER //
// Page-tinymce.vue?38a8b49c